import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";

import { Helmet } from "react-helmet";

import Sidebar from "../../Sidebar/Sidebar";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import ShipsContent from "./ShipsContent";
import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";
import BannerRectangle from "../../Banner/BannerRectangle";
import { getLanguage } from "../../Translation/Translation";


class Ships extends Component {
  render() {
    return (
      <div>
        <Grid fluid className="no-padding">
          <Helmet>
            <title>Route Analysis | Openseas</title>
          </Helmet>
          <Row style={{ margin: "0px" }}>
            <Col style={{ margin: "0px" }}>
              <Header data={this.props} />
            </Col>
          </Row>
          <Row style={{ margin: "0px" }}>
            <div className="OSPageContainer">
              <div className="OSPageContent">
                <ShipsContent data={this.props} language={getLanguage()} />
              </div>
              <div className="OSPageSidebar">
                <Sidebar />
              </div>
            </div>
          </Row>
          <Row style={{ margin: "24px 0px 24px 0" }}>
            <div className="displayBannerLarge">
              <BannerRectangleLarge />
            </div>
          </Row>
          <Row>
            <Col xs={12} sm={6} mdHidden lgHidden>
              <BannerRectangle />
            </Col>
            <Col xsHidden sm={6} mdHidden lgHidden>
              <BannerRectangle />
            </Col>
          </Row>
          <Row style={{ margin: "0px" }}>
            <Footer />
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Ships;



// WEBPACK FOOTER //
// ./src/components/Pages/Ships/Ships.js